import { render, staticRenderFns } from "./error-list.vue?vue&type=template&id=16053dc0&"
import script from "./error-list.vue?vue&type=script&lang=js&"
export * from "./error-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports